import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SalesPresentationService } from '@services/api/sale-presentation.service';

@Injectable({
  providedIn: 'root',
})
export class SalePresentationService {
  sp_details: any;
  s3: any = environment.S3 + '/';

  constructor(private _salesPresentationService: SalesPresentationService) {}

  saveSP(projectId: any) {
    this._salesPresentationService.getSP(projectId).subscribe({
      next: (response: any) => {
        const { data } = response;

        if (data) {
          this.sp_details = data;
          this.resetImages(projectId);
        }
      },
    });
  }

  resetImages = (projectId: any) => {
    this._salesPresentationService.getSalesPresentationLibraryFolders(projectId).subscribe({
      next: (response: any) => {
        const { data } = response;
        data.forEach(item => {
          if (item.name === 'Interior' && item.type === 'folder') {
            let fol = item.childrens;
            let folders = [];
            let items = [];
            fol.forEach(f => {
              if (!f.is_deleted) {
                folders.push(f.name);
                items.push(f);
              }
            });
            this.sp_details.interior = this.filterByNames(this.sp_details.interior, folders);
            const missing = this.getMissingNames(this.sp_details.interior, folders);
            missing.forEach(f => {
              let item = items.find(a => a.name === f);
              this.sp_details.interior.push({
                name: f,
                is360: false,
                image: item.childrens.length > 0 ? this.s3 + item.childrens[0].path : '',
              });
            });
            this.sp_details.interior.forEach(s => {
              if (!s.image) {
                let item = items.find(a => a.name === s.name);
                s.image = item.childrens.length > 0 ? this.s3 + item.childrens[0].path : '';
              }
            });
          }

          if (item.name === 'Amenities' && item.type === 'folder') {
            let fol = item.childrens;
            let folders = [];
            let items = [];
            fol.forEach(f => {
              if (!f.is_deleted) {
                folders.push(f.name);
                items.push(f);
              }
            });
            this.sp_details.amenities = this.filterByNames(this.sp_details.amenities, folders);
            const missing = this.getMissingNames(this.sp_details.amenities, folders);
            missing.forEach(f => {
              let item = items.find(a => a.name === f);
              this.sp_details.amenities.push({
                name: f,
                is360: false,
                image: item.childrens.length > 0 ? this.s3 + item.childrens[0].path : '',
              });
            });
            this.sp_details.amenities.forEach(s => {
              if (!s.image) {
                let item = items.find(a => a.name === s.name);
                s.image = item.childrens.length > 0 ? this.s3 + item.childrens[0].path : '';
              }
            });
          }

          if (item.name === 'Views' && item.type === 'folder') {
            let fol = item.childrens;
            let folders = [];
            let items = [];
            fol.forEach(f => {
              folders.push(f.name ? f.name.replace(/\.[^/.]+$/, '') : '');
              items.push({
                name: f.name ? f.name.replace(/\.[^/.]+$/, '') : '',
                path: this.s3 + f.path,
              });
            });
            this.sp_details.views = this.filterByNames(this.sp_details.views, folders);
            const missing = this.getMissingNames(this.sp_details.views, folders);
            missing.forEach(f => {
              let find = items.find(c => c.name === f);
              if (find) {
                this.sp_details.views.push({
                  name: f,
                  is360: false,
                  image: find.path,
                });
              }
            });
          }

          if (item.name === 'Gallery' && item.type === 'folder') {
            this.sp_details.isGallery = this.checkFilesAndFolders(item.childrens);
          }

          if (item.name === 'Brochure' && item.type === 'folder') {
            this.sp_details.isBrochure = item?.childrens?.length > 0 ? item?.childrens?.length : 0;
          }
        });

        this._salesPresentationService.saveSP(this.sp_details).subscribe({
          next: _ => {},
        });
      },
    });
  };

  getMissingNames(items: { name: string; image: string }[], names: string[]): string[] {
    const itemNames = items.map(item => item.name);
    return names.filter(name => !itemNames.includes(name));
  }

  filterByNames(items: { name: string; image: string }[], names: string[]) {
    return items.filter(item => names.includes(item.name));
  }

  checkFilesAndFolders(items: Item[]): { hasFile: boolean; folderCount: number } {
    let folderCount = 0;
    let hasFile = false;

    function traverse(array: Item[]) {
      for (const item of array) {
        if (item.type === 'file') {
          hasFile = true;
          return; // stop early if we found a file
        }
        if (item.type === 'folder') {
          folderCount++;
          if (item.childrens && item.childrens.length > 0) {
            traverse(item.childrens);
            if (hasFile) return; // stop early
          }
        }
      }
    }

    traverse(items);
    return { hasFile, folderCount };
  }
}
interface Item {
  type: 'folder' | 'file';
  childrens?: Item[];
  [key: string]: any;
}
